import "./sidebar.css";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import ChatIcon from "@mui/icons-material/Chat";
import PlayCircleFilledOutlinedIcon from "@mui/icons-material/PlayCircleFilledOutlined";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import EventIcon from "@mui/icons-material/Event";
import CloseFriend from "../closeFriend/CloseFriend";
import { Link } from "react-router-dom"
import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";

export default function Sidebar() {
  const { user } = useContext(AuthContext);
  const [followings, setFollowings] = useState([]);

  useEffect(() => {
    const getFollowings = async () => {
      try {
        const followingsList = await axios.get(
          "https://conexus-api.vercel.app/api/users/followings/" + user._id
        );
        setFollowings(followingsList.data);
      } catch (err) {
        console.log(err);
      }
    };
    getFollowings();
  }, []);

  return (
    <div className="sidebar">
      <div className="sidebarWrapper">
        <ul className="sidebarList">
          <li className={"sidebarListItem active"}>
            <Link to="/">
              <RssFeedIcon htmlColor="white" className="sidebarIcon" />
              <span className="sidebarListItemText">Feed</span>
            </Link>
          </li>
          <li className="sidebarListItem">
            <Link to="/">
              <ChatIcon htmlColor="white" className="sidebarIcon" />
              <span className="sidebarListItemText">Chats</span>
            </Link>
          </li>
          <li className="sidebarListItem">
            <Link to="/">
              <PlayCircleFilledOutlinedIcon
                htmlColor="white"
                className="sidebarIcon"
              />
              <span className="sidebarListItemText">Videos</span>
            </Link>
          </li>
          <li className="sidebarListItem">
            <Link to="/">
              <BookmarkIcon htmlColor="white" className="sidebarIcon" />
              <span className="sidebarListItemText">Bookmarks</span>
            </Link>
          </li>
          <li className="sidebarListItem">
            <Link to="/">
              <HelpOutlineIcon htmlColor="white" className="sidebarIcon" />
              <span className="sidebarListItemText">Questions</span>
            </Link>
          </li>
          <li className="sidebarListItem">
            <Link to="/">
              <EventIcon htmlColor="white" className="sidebarIcon" />
              <span className="sidebarListItemText">Events</span>
            </Link>
          </li>
          <div className="sidebarListAnimation"></div>
        </ul>
        <hr className="sidebarHr" />
        <h2 className="sidebarTitle">Your Followings</h2>
        <ul className="sidebarFriendList">
          {followings.map((u, idx) => (
            <CloseFriend key={idx} user={u} />
          ))}
        </ul>
      </div>
    </div>
  );
}
